import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  IconButton,
  Stack,
} from "@mui/material";
import {
  BarChart,
  Psychology,
  Flag,
  Lock,
  VisibilityOutlined,
  EmojiObjectsOutlined,
  HomeOutlined,
  AssistantOutlined,
} from "@mui/icons-material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";

const MainScreen = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f3f4f6", // soft grey background
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: 2,
        py: 6,
      }}
    >
      {/* Logo + Tagline */}
      <Container maxWidth="sm" sx={{ textAlign: "center" }}>
        <img
          src="/my-networth12.png"
          alt="My Net Worth Logo"
          style={{ width: "100%", maxWidth: 260, marginBottom: 16 }}
        />
        <Typography variant="h6" sx={{ color: "#374151", fontWeight: 600, mb: 1 }}>
          From your first home to lasting wealth — plan smart with AI.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Trusted personal finance platform making wealth creation simple,
          structured, and accessible.
        </Typography>
      </Container>

      {/* Vision & Mission */}
      <Paper
        elevation={2}
        sx={{
          mt: 6,
          p: 3,
          width: "100%",
          maxWidth: 500,
          borderRadius: 3,
          backgroundColor: "#f9fafb", // light grey card
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Stack spacing={1}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <VisibilityOutlined sx={{ color: "#6b7280" }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  Vision
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                To democratize wealth creation by making personalized financial
                planning simple, intelligent, and accessible to every aspiring household.
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Stack spacing={1}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <EmojiObjectsOutlined sx={{ color: "#6b7280" }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  Mission
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                We guide first-time home buyers in India through a personalized,
                AI-powered journey — simplifying savings, demystifying decisions,
                and helping them build long-term prosperity with confidence.
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Paper>

      {/* PMF Feature Card */}
      <Paper
        elevation={2}
        sx={{
          mt: 6,
          p: 3,
          width: "100%",
          maxWidth: 500,
          borderRadius: 3,
          backgroundColor: "#f9fafb",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 12,
            right: -24,
            transform: "rotate(45deg)",
            backgroundColor: "#d1d5db",
            color: "#000",
            fontWeight: "bold",
            px: 2,
            py: 0.5,
            fontSize: 12,
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          Coming Soon
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Stack spacing={1}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <HomeOutlined sx={{ color: "#6b7280" }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  Overwhelmed buying your first home?
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ pl: 4 }}>
                From planning your down payment to navigating EMIs and paperwork — first-time home buying is confusing and stressful.
              </Typography>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Stack spacing={1}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <AssistantOutlined sx={{ color: "#6b7280" }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  We’re building your guided path.
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ pl: 4 }}>
                Our upcoming AI-powered home planning tool helps you save smart, learn as you go, and reach your home goal — step-by-step.
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Paper>

      {/* Contact Section */}
      <Box sx={{ mt: 6, textAlign: "center" }}>
        <Typography variant="h6" sx={{ mb: 1, color: "#4b5563" }}>
          Connect With Us
        </Typography>
        <Stack direction="row" justifyContent="center" spacing={2}>
          <IconButton
            href="https://www.linkedin.com/company/my-networth/"
            target="_blank"
            aria-label="LinkedIn"
          >
            <LinkedInIcon sx={{ color: "#4b5563" }} />
          </IconButton>
          <IconButton href="mailto:upendra@my-networth.com" aria-label="Email">
            <EmailIcon sx={{ color: "#4b5563" }} />
          </IconButton>
        </Stack>
      </Box>

      {/* Footer */}
      <Box sx={{ mt: 6 }}>
        <Typography variant="body2" color="text.secondary" align="center">
          &copy; 2025 MY NETWORTH. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default MainScreen;
